export const appHead = {"meta":[{"charset":"utf-8"},{"name":"description","content":"Conseil stratégique au service des dirigeants. Réflexions stratégiques, optimisation de l'organisation et mise en œuvre des leviers de performance."},{"name":"keywords","content":"Conseil, stratégie, optimisation, performance"},{"name":"viewport","content":"width=device-width, initial-scale=1, interactive-widget=resizes-content"},{"name":"theme-color","content":"#1bb3af"},{"property":"og:title","content":"Baghera Advisory"},{"property":"og:description","content":"Conseil stratégique au service des dirigeants. Réflexions stratégiques, optimisation de l'organisation et mise en œuvre des leviers de performance."},{"property":"og:type","content":"website"},{"property":"og:locale","content":"fr_FR"},{"property":"og:site_name","content":"Baghera Advisory"},{"property":"og:image","content":"//baghera-advisory.fr/img/desktop/panther_1440x532.webp"},{"property":"og:image:width","content":"1440"},{"property":"og:image:height","content":"532"},{"property":"og:image:type","content":"image/webp"},{"name":"twitter:card","content":"summary_large_image"},{"name":"twitter:title","content":"Baghera Advisory"},{"name":"twitter:description","content":"Conseil stratégique au service des dirigeants. Réflexions stratégiques, optimisation de l'organisation et mise en œuvre des leviers de performance."},{"name":"twitter:image","content":"//baghera-advisory.fr/img/desktop/panther_1440x532.webp"},{"name":"google-site-verification","content":"u6HSBzgih2XfLyyUDwv70VRFyvasLyIV9nUIFqbfQzQ"}],"link":[{"rel":"preconnect","href":"https://www.google-analytics.com"},{"rel":"preconnect","href":"https://fonts.googleapis.com"},{"rel":"preconnect","href":"https://fonts.gstatic.com","crossorigin":""},{"rel":"stylesheet","href":"https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap"},{"rel":"apple-touch-icon","href":"/apple-icon-57x57.png","sizes":"57x57"},{"rel":"apple-touch-icon","href":"/apple-icon-60x60.png","sizes":"60x60"},{"rel":"apple-touch-icon","href":"/apple-icon-72x72.png","sizes":"72x72"},{"rel":"apple-touch-icon","href":"/apple-icon-76x76.png","sizes":"76x76"},{"rel":"apple-touch-icon","href":"/apple-icon-114x114.png","sizes":"114x114"},{"rel":"apple-touch-icon","href":"/apple-icon-120x120.png","sizes":"120x120"},{"rel":"apple-touch-icon","href":"/apple-icon-144x144.png","sizes":"144x144"},{"rel":"apple-touch-icon","href":"/apple-icon-152x152.png","sizes":"152x152"},{"rel":"apple-touch-icon","href":"/apple-icon-180x180.png","sizes":"180x180"},{"rel":"icon","type":"image/png","sizes":"192x192","href":"/android-icon-192x192.png"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"/favicon-32x32.png"},{"rel":"icon","type":"image/png","sizes":"96x96","href":"/favicon-96x96.png"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"/favicon-16x16.png"},{"rel":"manifest","href":"/manifest.json"}],"style":[],"script":[],"noscript":[],"title":"Baghera Advisory","htmlAttrs":{"lang":"fr"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = true